import { render, staticRenderFns } from "./ProductIssue.vue?vue&type=template&id=1feb33bf&"
import script from "./ProductIssue.vue?vue&type=script&lang=js&"
export * from "./ProductIssue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports